<div>

    <div class="b2c-notfound back-o-er-bg">
        <div class="b2c-notfound-error">

            <span class="text-center"><img src="assets/images/error-back-img.png" width="150px"></span>

        </div>

        <div>
            <h2>Site under maintenance!</h2>
            <p>The page you are looking for might have been removed had its name changed or is temporarily unavailable.
            </p>
            <a href="/">Back to page</a>
        </div>
    </div>


</div>